module.exports = __webpack_public_path__ + "static/projekt_indywidualny_a07-e4268ddf6e04472fb8e4a796d36cc9cc.jpg";